import Swal from 'sweetalert2';
import { escapeHtml } from '../../../shared/escape-html.utils';

/** Arma HTML de apertura. */
export function openPeriodHtml(monthLabel: string): string {
  return `<p class="text-warning"><i class="fas fa-triangle-exclamation"></i> Aún no ha abierto ninguna evaluación para <b>${escapeHtml(monthLabel)}</b>.</p>` +
    `<p>Se crearán periodos para las entidades del grupo seleccionado.</p>` +
    `<div class="text-start mt-3"><label class="form-label">Fecha expiración</label><input id="swal-exp" type="date" class="form-control"></div>`;
}

/** Lee valor de input. */
export function inputValue(id: string): string {
  return (document.getElementById(id) as HTMLInputElement)?.value ?? '';
}

/** Lee check de forzado. */
export function forceChecked(id: string): boolean {
  return (document.getElementById(id) as HTMLInputElement)?.checked ?? false;
}

/** Indica si falta fecha. */
export function missingDate(exp: string): boolean {
  return exp === '';
}

/** Falla validación con mensaje. */
export function validationFail(message: string): false {
  Swal.showValidationMessage(message);
  return false;
}

/** Lee apertura desde el diálogo. */
export function readOpenInput(): { expirationDate: string } | false {
  const exp = inputValue('swal-exp');
  if (missingDate(exp) === true) return validationFail('Seleccione fecha de expiración');
  return { expirationDate: exp };
}

/** Arma HTML de reapertura. */
export function reopenHtml(count: number, monthLabel: string): string {
  return `<p>Se reabrirán <b>${count}</b> periodo(s) de <b>${escapeHtml(monthLabel)}</b>. Se mantendrán las respuestas y archivos guardados, y se permitirá seguir trabajando.</p>` +
    `<div class="text-start mt-3"><label class="form-label">Nueva fecha expiración</label><input id="swal-exp-re" type="date" class="form-control"></div>`;
}

/** Lee reapertura desde el diálogo. */
export function readReopenInput(): string | false {
  const exp = inputValue('swal-exp-re');
  if (missingDate(exp) === true) return validationFail('Seleccione fecha de expiración');
  return exp;
}

/** Arma HTML de edición. */
export function editHtml(expVal: string, scoreVal: unknown): string {
  return `<div class="text-start"><label class="form-label">Fecha vencimiento</label><input id="swal-edit-exp" type="date" class="form-control" value="${escapeHtml(expVal)}"></div>` +
    `<div class="text-start mt-3"><label class="form-label">Puntaje</label><input id="swal-edit-score" type="number" class="form-control" min="0" max="100" value="${escapeHtml(scoreVal)}"></div>`;
}

/** Toma fecha de periodo. */
export function periodDate(period: { expiration?: unknown }): string {
  return splitDate(period.expiration);
}

/** Corta hora de fecha. */
export function splitDate(value: unknown): string {
  if (value) return String(value).split('T')[0];
  return '';
}

/** Toma puntaje de periodo. */
export function periodScore(period: { score?: unknown }): number {
  return Number(period?.score ?? 0);
}

/** Indica si el puntaje es válido. */
export function validScore(text: string, score: number): boolean {
  return isScoreText(text, score) === true;
}

/** Valida texto y rango de puntaje. */
export function isScoreText(text: string, score: number): boolean {
  if (text === '') return false;
  return inScoreRange(score);
}

/** Indica si está en rango 0-100. */
export function inScoreRange(score: number): boolean {
  return score >= 0 && score <= 100;
}

/** Lee edición desde el diálogo. */
export function readEditInput(): { expiration: string; score: number } | false {
  const exp = inputValue('swal-edit-exp');
  if (missingDate(exp) === true) return validationFail('Seleccione fecha de vencimiento');
  return buildEditResult(exp);
}

/** Construye resultado de edición. */
export function buildEditResult(exp: string): { expiration: string; score: number } | false {
  const text = inputValue('swal-edit-score');
  const score = Number(text);
  if (validScore(text, score) === false) return validationFail('Puntaje 0-100');
  return { expiration: exp, score };
}

/** Indica si fue confirmado con valor. */
export function confirmedWithValue(result: { isConfirmed: boolean; value: unknown }): boolean {
  return result.isConfirmed && Boolean(result.value);
}

/** Extrae valor confirmado o nulo. */
export function confirmedValue<T>(result: { isConfirmed: boolean; value: T }): T | null {
  if (confirmedWithValue(result) === true) return result.value;
  return null;
}
